export const SUPPORT_AGENT = 'Support Agent';
export const SUPPORT_LEAD = 'Support Lead';
export const ACCOUNT_ADMIN = 'Account Admin';
export const DATA_ANALYSIS = 'Data Analysis';

export const allowedUserRoles = [SUPPORT_AGENT, SUPPORT_LEAD, ACCOUNT_ADMIN, DATA_ANALYSIS];
